export default "__VITE_ASSET__BvyDjFQb__"